import { setNetwork } from '@utils/network';

export const NETWORK = {
  OPDEV: 'opdev',
  SB: 'sb',
  RC: 'rc',
  STAGE: 'stage',
  LIVE: 'live',
};

export const SERVICE_ALIAS = {
  LINEAGE: 'lineage',
  LINEAGE2: 'lineage2',
  AION: 'aion',
  BNS: 'bns',
  LINEAGEM: 'lineagem',
};

export const OLD_NSHOP_ALIAS = {
  [SERVICE_ALIAS.LINEAGE]: 'lineage',
  [SERVICE_ALIAS.LINEAGE2]: 'lineage2',
  [SERVICE_ALIAS.AION]: 'aion',
  [SERVICE_ALIAS.BNS]: 'bns',
};

export const NSHOP_ALIAS = {
  [SERVICE_ALIAS.LINEAGE]: 'lin',
  [SERVICE_ALIAS.LINEAGE2]: 'lin2',
  [`${SERVICE_ALIAS.LINEAGE2}_awakeningGoods`]: 'lin2awkn',
  [SERVICE_ALIAS.AION]: 'aion',
  [`${SERVICE_ALIAS.AION}_classicGoods`]: 'aionc',
  [SERVICE_ALIAS.BNS]: 'bns',
  [`${SERVICE_ALIAS.BNS}_neoGoods`]: 'bnsneo',
};

export const GAME_NAME = {
  [SERVICE_ALIAS.AION]: {
    LIVE: 'aion',
    CLASSIC: 'aionclassic',
  },
  [SERVICE_ALIAS.LINEAGE2]: {
    L2: 'l2',
    L2AWKN: 'l2awkn',
  },
  [SERVICE_ALIAS.BNS]: {
    LIVE: 'bns',
    NEO: 'bnsneo',
  },
};

export const SERVER_TYPE = {
  [SERVICE_ALIAS.AION]: {
    LIVE: 'live',
    CLASSIC: 'classic',
  },
  [SERVICE_ALIAS.LINEAGE2]: {
    L2: 'aden',
    L2AWKN: 'work',
  },
  [SERVICE_ALIAS.BNS]: {
    LIVE: 'live',
    NEO: 'neo',
  },
};

export const SEARCH_TYPE = {
  [SERVICE_ALIAS.AION]: {
    DEFAULT: 'default',
    EQUIPMENT: 'equipment',
  },
};

export const COMMUNITY_SERVER_TYPE = {
  [SERVICE_ALIAS.LINEAGE2]: {
    L2: 'lin2',
    L2AWKN: 'lin2_awkn',
  },
};

export const CUR_NETWORK = setNetwork();

export const LANGUAGE = document.querySelector('html')?.lang || 'ko';
export const COUNTRY = document.querySelector('html')?.dataset?.country || 'KR';

export const GUIDEBOOK_TAG_URL = {
  [SERVICE_ALIAS.LINEAGE2]: '/guidebook/{GAME_NAME}/search#field=tags&keyword=',
  [SERVICE_ALIAS.AION]: '/guidebook/view?title=',
  [SERVICE_ALIAS.LINEAGEM]: '/guidebook/search#field=tags&keyword=',
};

export const TAG_URL = {
  [SERVICE_ALIAS.LINEAGE]: '/search/tagContent?query=',
  [SERVICE_ALIAS.LINEAGE2]: '/search/tagContent?query=',
  [SERVICE_ALIAS.BNS]: '/search/tag?query=',
  [SERVICE_ALIAS.AION]: '/search/tagContent?query=',
  [SERVICE_ALIAS.LINEAGEM]: '/search/tag?query=',
};

export const STATIC_DOMAIN = {
  [NETWORK.OPDEV]: 'https://op-assets.ncsoft.com',
  [NETWORK.SB]: 'https://assets.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-assets.playnccdn.com',
  [NETWORK.STAGE]: 'https://stage-assets.playnccdn.com',
  [NETWORK.LIVE]: 'https://assets.playnccdn.com',
};

export const SANDBOX_DOMAIN = {
  [NETWORK.OPDEV]: 'https://sandbox.sb.plaync.com',
  [NETWORK.SB]: 'https://sandbox.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-sandbox.plaync.com',
  [NETWORK.STAGE]: 'https://sandbox.plaync.com',
  [NETWORK.LIVE]: 'https://sandbox.plaync.com',
};
export const PROFILE_IMG_DOMAIN = {
  [NETWORK.OPDEV]: 'https://profileimg-ncs.sb.plaync.com',
  [NETWORK.SB]: 'https://profileimg-ncs.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-profileimg.plaync.com',
  [NETWORK.STAGE]: 'https://profileimg.plaync.com',
  [NETWORK.LIVE]: 'https://profileimg.plaync.com',
};

export const FAQ_DOMAIN = {
  [NETWORK.OPDEV]: 'https://help.sb.plaync.com',
  [NETWORK.SB]: 'https://help.sb.plaync.com',
  [NETWORK.RC]: 'https://rc-help.plaync.com',
  [NETWORK.STAGE]: 'https://help.plaync.com',
  [NETWORK.LIVE]: 'https://help.plaync.com',
};

export const NCTV_DOMAIN = {
  [NETWORK.OPDEV]: 'https://rc-nctv.plaync.com',
  [NETWORK.SB]: 'https://rc-nctv.plaync.com',
  [NETWORK.RC]: 'https://rc-nctv.plaync.com',
  [NETWORK.STAGE]: 'https://nctv.plaync.com',
  [NETWORK.LIVE]: 'https://nctv.plaync.com',
};

// 통합N샵 도메인
export const NSHOP_DOMAIN = {
  [NETWORK.OPDEV]: 'https://store.sb.plaync.com/store',
  [NETWORK.SB]: 'https://store.sb.plaync.com/store',
  [NETWORK.RC]: 'https://rc-store.plaync.com/store',
  [NETWORK.STAGE]: 'https://store.plaync.com/store',
  [NETWORK.LIVE]: 'https://store.plaync.com/store',
};

// 기존N샵 도메인(추후 제거 예정)
export const OLD_NSHOP_DOMAIN = {
  [SERVICE_ALIAS.LINEAGE]: {
    [NETWORK.OPDEV]: 'https://lineagenshop.sb.plaync.com/',
    [NETWORK.SB]: 'https://lineagenshop.sb.plaync.com/',
    [NETWORK.RC]: 'https://rc-lineagenshop.plaync.com/',
    [NETWORK.STAGE]: 'https://lineagenshop.plaync.com/',
    [NETWORK.LIVE]: 'https://lineagenshop.plaync.com/',
  },
  [SERVICE_ALIAS.LINEAGE2]: {
    [NETWORK.OPDEV]: 'https://lineage2nshop.sb.plaync.com/',
    [NETWORK.SB]: 'https://lineage2nshop.sb.plaync.com/',
    [NETWORK.RC]: 'https://rc-lineage2nshop.plaync.com/',
    [NETWORK.STAGE]: 'https://lineage2nshop.plaync.com/',
    [NETWORK.LIVE]: 'https://lineage2nshop.plaync.com/',
  },
  [SERVICE_ALIAS.BNS]: {
    [NETWORK.OPDEV]: 'https://bnsnshop.sb.plaync.com/',
    [NETWORK.SB]: 'https://bnsnshop.sb.plaync.com/',
    [NETWORK.RC]: 'https://rc-bnsnshop.plaync.com/',
    [NETWORK.STAGE]: 'https://bnsnshop.plaync.com/',
    [NETWORK.LIVE]: 'https://bnsnshop.plaync.com/',
  },
  [SERVICE_ALIAS.AION]: {
    [NETWORK.OPDEV]: 'https://aionnshop.sb.plaync.com/',
    [NETWORK.SB]: 'https://aionnshop.sb.plaync.com/',
    [NETWORK.RC]: 'https://rc-aionnshop.plaync.com/',
    [NETWORK.STAGE]: 'https://aionnshop.plaync.com/',
    [NETWORK.LIVE]: 'https://aionnshop.plaync.com/',
  },
};
